export enum Language {
  ENGLISH = 'English',
  NORWEGIAN = 'Norwegian',
}
